import axios from 'axios'
import {
  BankBranchNameResponse, BankNameResponse
} from '@/types/api'

const baseUrl = `${process.env.VUE_APP_API_URL_BASE}/bank`

export default {
  // 銀行名一覧検索API
  search (params: {bankName: string}): Promise<BankNameResponse[]> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}`, { params })
        .then(({ data }: { data: BankNameResponse[] }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  },
  // 支店名検索API
  findBankBranch (params: {code: string|null|undefined; branchName: string}): Promise<BankBranchNameResponse[]> {
    return new Promise((resolve, reject) => {
      axios.get(`${baseUrl}/branch`, { params })
        .then(({ data }: { data: BankBranchNameResponse[] }) => {
          resolve(data)
        }).catch((errors) => {
          reject(errors)
        })
    })
  }

}
